import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck'
import faClose from '@fortawesome/fontawesome-free-solid/faTimes'
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope'
import CircularProgress from 'material-ui/CircularProgress'
import { RoundButtonText } from './'

import * as Constants from '../../helpers/Constants'

class RoundButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  getStyle() {
    const {
      className = 'primary',
      disabled,
      height = 75,
      width = 75
    } = this.props
    const standardStyle = {
      height,
      width,
      borderRadius: 37.5,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      margin: 10
    }
    const { hover } = this.state
    if (disabled || className === 'warning')
      standardStyle.cursor = 'not-allowed'
    switch (className) {
      case 'primary':
        standardStyle.backgroundColor = hover ? '#77d8f4' : '#3fa6c1'
        break
      case 'success':
        standardStyle.backgroundColor = hover
          ? Constants.WHITE_LABEL.colors.primaryHover
          : Constants.WHITE_LABEL.colors.primary
        break
      case 'warning':
        standardStyle.backgroundColor = hover
          ? Constants.WHITE_LABEL.colors.warningHover
          : Constants.WHITE_LABEL.colors.warning
        break
      case 'passed':
        standardStyle.backgroundColor = 'rgb(244, 244, 248)'
        break
      case 'subscribe':
        standardStyle.backgroundColor = hover
          ? Constants.WHITE_LABEL.colors.primaryHover
          : Constants.WHITE_LABEL.colors.primary
        break
      case 'unsubscribe':
        standardStyle.backgroundColor = hover
          ? Constants.WHITE_LABEL.colors.warningHover
          : Constants.WHITE_LABEL.colors.warning
        break
      default:
    }
    return standardStyle
  }

  getContent() {
    const { loading } = this.props
    if (loading) {
      return <CircularProgress color={'white'} size={20} />
    } else {
      return this.renderContent()
    }
  }

  renderContent() {
    const { className = 'primary', text = '' } = this.props
    switch (className) {
      case 'primary':
        return <RoundButtonText text={text} />
      case 'success':
        return <FontAwesomeIcon icon={faCheck} color={'white'} />
      case 'warning':
        return <FontAwesomeIcon icon={faClose} color={'white'} />
      case 'subscribe':
        return (
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} color={'white'} />
            <p style={{ color: 'white', margin: 0, fontSize: 10 }}>Bevaka</p>
          </div>
        )
      case 'unsubscribe':
        return (
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} color={'white'} />
            <p style={{ color: 'white', margin: 0, fontSize: 10 }}>Avbevaka</p>
          </div>
        )
      default:
    }
  }

  render() {
    const { onClick = {}, cssClass } = this.props
    return (
      <a
        className={'ShadowContainer ' + cssClass}
        style={this.getStyle()}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
      >
        {this.getContent()}
      </a>
    )
  }
}

export { RoundButton }



// WEBPACK FOOTER //
// ./src/components/common/RoundButton.js